/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { ControlDefinition } from "@anvilor/ngx-rui";
import { LegacyRuiControl } from "@anvilor/ngx-rui";
import { RuiStore } from "@anvilor/ngx-rui";

export const CONTROL_RECAPTCHA_CHALLENGE = "anvilor_forms:recaptcha_challenge";

export interface RecaptchaChallengeControlDefinition extends ControlDefinition {
  control: typeof CONTROL_RECAPTCHA_CHALLENGE;
}

// QUESTION - why no format!?
// eslint-disable-next-line max-len
export class RecaptchaChallengeControl extends LegacyRuiControl<RecaptchaChallengeControlDefinition> {
  constructor(store: RuiStore, id: string) {
    super(store, id);
  }
}
